import {Component, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-partner-search-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./partner-search-page.component.html",
    standalone: false
})
export class PartnerSearchPageComponent implements OnInit {

    gridData: any[] = [];


    constructor(private http: HttpClient,
                private auth: AuthApiService,
                private router: Router,
                private errorHandler: ErrorHandlerService,
                private spinnersService: FUISpinnersService) {
    }

    ngOnInit(): void {
        this.load();

    }

    load(): void {
        this.spinnersService.open();
        this.http.get<any[]>("/fonzie/partners", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe((data) => {
                this.spinnersService.close();
                this.gridData = data;
            });
    }

    addNew(): void {
        this.router.navigate(["/main/partner-edit"]);
    }

}
